module.exports = __webpack_public_path__ + "img/balance_bg.3cc4afd6.png";